import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp-gift-card.scss';

export default class GiftcardPageController extends Controller {
  static get COMPONENTS() {
    return [
      'PdpGiftCardComponent',
      'DatePickerComponent'
    ];
  }
}
